import React, { Component } from "react";
import ReactDOM from "react-dom";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import styles from "react-responsive-carousel/lib/styles/carousel.min.css";

class DemoCarousel extends Component {
  render() {
    return (
      <div className="project-head">
        <h1 className="project-title" id="projectsid">
          Projects
        </h1>
        <Carousel className="project-carousel">
          <div>
            <img src="omnifoodimg.jpg" className="img1" />
            <p className="legend ">
              <h4>Designing and building a real world project OMNIFOOD: </h4>
              <br />
              Omnifood is food delivering website which provides information,
              menus, and user-reviews of restaurants as well as food delivery
              options. This website is build using Html, Css, Javascript in
              Visual studio code.
              <a
                href="https://omnifood-balaji.netlify.app/"
                target="_blank"
                className="project-link"
              >
                Project Link
              </a>
            </p>
          </div>
          <div>
            <img src="figmaimg.jpg" />
            <p className="legend">
              <h4>Designing a portfolio in Figma: </h4>
              <br />
              Using UI UX Design, I have designed my portfolio in Figma.
              <a
                href=" 
https://www.figma.com/file/lzX2edZ6QmeIuPMlUAKBrl/Balajiuiux?node-id=0%3A1&t=EQrbLhQJ8eGt7bza-1"
                target="_blank"
                className="project-link"
              >
                Project Link
              </a>
            </p>
          </div>
          <div>
            <img src="chairimg.jpg" />
            <p className="legend">
              <h4>Building an e-commerce website for selling chairs: </h4>
              <br />
              Using Html and Css, I designed a website which sells chairs for
              the customers by showcasing their products in website.
              <a
                href="https://e-comm-chair-balaji.netlify.app/"
                target="_blank"
                className="project-link"
              >
                Project Link
              </a>
            </p>
          </div>
          <div>
            <img src="guessmynumberimg.jpg" />
            <p className="legend">
              <h4>Guess my number game: </h4>
              <br />
              Guess my number is the game in which player has to guess the
              number correctly within 20 choices or else game will get over.
              <a
                href="https://game-guessmynumber-balaji.netlify.app/"
                target="_blank"
                className="project-link"
              >
                Project Link
              </a>
            </p>
          </div>
        </Carousel>
      </div>
    );
  }
}

export default DemoCarousel;
// ReactDOM.render(<DemoCarousel />, document.querySelector('.demo-carousel'));
